import { RouteObject } from 'react-router-dom';
import { CompanyFormulario } from '@/pages/company/formulario';

// import CompanyLayout from '@/layouts/CompanyLayout';
// import { CompanyLogin } from '@/pages/company/auth';
// import { CompanyDashboard } from '@/pages/company/dashboard';
// import { CompanyInterpretacao } from '@/pages/company/interpretacao';

/**
 * Portal colaborador: ativo só `/empresa/formulario/:companyId`.
 * Login/dashboard/interpretação desativados (comentados abaixo).
 * `/empresa/login`, `/empresa/dashboard`, etc. não têm rota → cai no `*` (NotFound).
 *
 * `/empresa` (sem sufixo) = landing B2B em `publicRoutes` — nunca usar `path: '/empresa'`
 * com `CompanyLayout`, senão o painel “toma” a home de marketing.
 */
export const companyRoutes: Array<RouteObject> = [
	{
		path: '/empresa/formulario/:companyId',
		element: <CompanyFormulario />,
	},

	/*
  // ─── Portal empresa com login (DESATIVADO — não apagar) ─────────────────────
  // Ao reativar: descomentar imports no topo + este bloco.
  // `/empresa` continua só na landing (`publicRoutes` → BusinessLanding).
  {
    path: '/empresa/login',
    element: <CompanyLogin />,
  },
  {
    element: <CompanyLayout />,
    children: [
      {
        path: '/empresa/dashboard',
        element: <CompanyDashboard />,
      },
      {
        path: '/empresa/interpretacao',
        element: <CompanyInterpretacao />,
      },
    ],
  },
  */
];
